export function checkUpdatedActiveCookieCategories(
  currentCookieCategories: string[],
  activeCookieCategories: string[]
): string[] {
  currentCookieCategories.forEach((currentCategory) => {
    const categoryStillActive = checkIfCategoryStillActive(
      currentCategory,
      activeCookieCategories
    );
    if (!categoryStillActive) {
      location.reload();
    }
  });
  return activeCookieCategories;
}

function checkIfCategoryStillActive(
  currentCategory: string,
  activeCookieCategories: string[]
): string | undefined {
  return activeCookieCategories.find((ac: string) => ac === currentCategory);
}
